var MuiFormControl = {
    /* your custom class style overrides here */
    root: {
        marginTop: 12,
    },
};
export default MuiFormControl;
//# sourceMappingURL=MuiFormControl.js.map